var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-popin-modal2",
    {
      attrs: {
        id: _vm.id,
        "aria-labelledby": "popin-customer-label",
        "show-close-button": false,
      },
    },
    [
      _c("div", { staticClass: "h4", attrs: { id: "popin-customer-label" } }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.subtitle
        ? _c("p", { staticClass: "mb-0 py-0" }, [
            _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("ob1-boutons", {
            staticClass: "mt-2 mb-1",
            attrs: {
              label: _vm.buttonLabel,
              "is-button": false,
              "is-secondary": "",
            },
            on: { "ob1-boutons-click": _vm.redirectToLink },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.text && _vm.linkLabelHtml && _vm.link
        ? [
            _c("ob1-separateur", { staticClass: "my-2" }),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.text))]),
            _vm._v(" "),
            _c("ob1-liens", {
              attrs: {
                text: _vm.linkLabelHtml,
                href: _vm.link,
                "is-large": "",
                "with-arrow": "",
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }